var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['info-item']},[_c('span',{class:_vm.$style.name},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }